import { render, staticRenderFns } from "./VerifyAnswer.vue?vue&type=template&id=2f5f3c39"
import script from "./VerifyAnswer.vue?vue&type=script&lang=js"
export * from "./VerifyAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports